import request from "@/utils/request";
import requestCache from "@/utils/requestWithCache";

export function getSurfaces(params) {
  return requestCache({
    url: "/api/admin/banners/surfaces/",
    method: "get",
    params,
  });
}
export function getSurfaceById(surfaceId) {
  return request({
    url: `/api/admin/banners/surfaces/${surfaceId}/`,
    method: "get",
  });
}
export function createSurface(data) {
  return request({
    url: `/api/admin/banners/surfaces/`,
    method: "post",
    data,
  });
}
export function deleteSurface(surfaceId) {
  return request({
    url: `/api/admin/banners/surfaces/${surfaceId}/`,
    method: "delete",
  });
}
export function updateSurface(surfaceId, data) {
  return request({
    url: `/api/admin/banners/surfaces/${surfaceId}/`,
    method: "patch",
    data,
  });
}
